export const appointmentColumns = [
  {
    label: 'Appointment start date',
    variations: [
      'Appointment Date',
      'appointment date',
      'Appointment Start Date',
      'appointment start date',
      'appointment'
    ],
    value: 'appointment_starts_at'
  },
  {
    label: 'Appointment duration',
    variations: [
      'Appointment Duration',
      'appointment duration',
      'Appointment End Date',
      'appointment end date'
    ],
    value: 'appointment_ends_at'
  },
  {
    label: 'Service',
    variations: ['Appointment Service', 'appointment service', 'service'],
    value: 'appointment_service'
  },
  {
    label: 'Appointment status',
    variations: ['Appointment Status', 'appointment status', 'status'],
    value: 'appointment_status'
  },
  {
    label: 'Appointment location',
    variations: ['Appointment Location', 'appointment location', 'location'],
    value: 'appointment_location'
  },
  {
    label: 'Appointment amount',
    variations: ['Appointment amount', 'appointment amount', 'amount'],
    value: 'appointment_amount'
  },
  {
    label: 'Appointment provider',
    variations: [
      'Appointment Provider',
      'appointment provider',
      'Provider',
      'Appointment Practitioner',
      'appointment practitioner',
      'Practitioner'
    ],
    value: 'appointment_provider'
  },
  { label: 'Transaction amount', variations: [], value: 'transaction_amount' },
  {
    label: 'Transaction amount paid self',
    variations: [],
    value: 'transaction_amount_paid_self'
  },
  { label: 'Transaction date', variations: [], value: 'transaction_date' }
];
